const initState={
    username:'',
    token:'',
    showNotification:false,
    userLtpatoken:'',
    userType:'STUDENT',
    isOLEaccount:false,
    allStudentResult:{},
    selectedCourse:'',
    selectedCourseSemester:'',
    selectedCourseActivity:'',
    selectedCourseActivityID:'',
    selectedStudentName:'',
    selectedStudentID:'',
    userInfoFromOle:{},
    
}

const initObj={
    username:'',
    token:'',
    showNotification:true,
    userType:'STUDENT', //staff
    userLtpatoken:'',
    isOLEaccount:false,
    allStudentResult:{},
    selectedCourse:'',
    selectedCourseSemester:'',
    selectedCourseActivity:'',
    selectedCourseActivityID:'',
    selectedStudentName:'',
    selectedStudentID:'',
    userInfoFromOle:{},
    
}

function userInfo(state = initState, action) {
    switch (action.type) {
      case 'SAVE_USERNAME'://for login by email - OTP
         return {...state,username:action.payload,userType:'STAFF',password:'',isOLEaccount:false}
      case 'SET_USERNAME_PASSWORD_AFTER_LOGIN':  //for login by ole
        let user_type='';
        let studentname = "";
        let studentid = ""
        // console.log("action.payload@SET_USERNAME_PASSWORD_AFTER_LOGIN:",action.payload);
        // console.log("action.payload@SET_USERNAME_PASSWORD_AFTER_LOGIN:",action.payload.username);
        var studentIdFormat = /^s\d{7}/;
        var tutorIdFormat = /^t\d{6}/;
        
        console.log("is student: "+studentIdFormat.test(action.payload.username));
        console.log("is tutor: "+tutorIdFormat.test(action.payload.username));
        
        if( studentIdFormat.test(action.payload.username) ) {
          user_type='STUDENT';
          studentname = action.payload.username;
          studentid = action.payload.username;
        }
        else if( tutorIdFormat.test(action.payload.username) ){
           user_type='STAFF';        
        }
        else {
          user_type='STAFF';
        }
        //console.log(usernameaction.payload.username);
        return {...state,
          username:action.payload.username,
          password:action.payload.password,
          userType:user_type,isOLEaccount:true,
          selectedStudentName:studentname,
          selectedStudentID:studentid,
        }
        // return {...state,username:action.payload.username,password:action.payload.password,userType:user_type,isOLEaccount:true}
      case 'SET_ISOLEACCOUNT':
        return {...state,isOLEaccount:action.payload}
      case'SAVE_TOKEN':
        return {...state,token:action.payload,isOLEaccount:false}
      case 'SET_SHOWNOTIFICATION':
        return {...state,showNotification:action.payload}
      case 'SET_USERLTPATOKEN':
        return {...state,userLtpatoken:action.payload}
      
      //Reset Course Data
      case 'RESET_COURSE':
        return {
          ...state,
          selectedCourse:"",
          selectedCourseSemester:"",
          selectedCourseActivity:"",
          selectedCourseActivityID:"",
        }
      //For Course Activity Page 
      case 'SET_SELECTEDCOURSE':
        return {...state,selectedCourse:action.payload}
      case 'SET_SELECTEDCOURSESEMESTER':
        return {...state,selectedCourseSemester:action.payload}
      case 'SET_SELECTEDACTIVITY':
        return {...state,selectedCourseActivity:action.payload}
      case 'SET_SELECTEDACTIVITYID':
        return {...state,selectedCourseActivityID:action.payload}
      case 'SET_SELECTEDSTUDENTNAME':
        return {...state,selectedStudentName:action.payload}
      case 'SET_SELECTEDSTUDENTID':
        return {...state,selectedStudentID:action.payload}
      case 'SET_ALLSTUDENTRESULT':
        return {...state,allStudentResult:action.payload}
      case 'SET_USERINFOFROMOLE':
        if (action.payload)
          action.payload.is_admin=action.payload?.is_admin=='true'?true:false
        return {...state,userInfoFromOle:action.payload}
      case 'SET_PARAMSFROMURL':
        const {course,form,sid}= action.payload||{};
        console.log('checkSET_PARAMSFROMURL1',course,form,sid)
        //console.log(action.payload)
        if (!course&&!form&&!sid){
          return {...state};
        }

        console.log('checkSET_PARAMSFROMURL2',course,form,sid)
        //sid=(sid.charAt(0))
        return {...state,selectedCourse:course,selectedCourseActivityID:form,selectedStudentID:sid}
      case 'INIT_INFO':
      case 'USER_LOGOUT':
        return initObj;
      default:
        return state
    }
  }

export default userInfo;